import React, { useState, useEffect } from 'react';
import { Bubble, Button, Row, Col, Select, Justify } from 'tea-component';
import { history, useIntl } from 'umi';
import MarketCardContext from '../../components/MarketCardContext';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import ProgressCard from '../components/ProgressCard';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Demographics.scss';
import { testBaseInfo } from '@/pages/intelligence/pages/MarketProfile/TabDetails/_config/_testData';
import { CDN_URL_DOMAIN } from '@/pages/intelligence/_config/config';
import { getFileKey } from '@gp/components/FileList/utils';
import { downloadFileByLinker, reportBtnOperationLog } from '@gp/utils/common';
import useCOS, { getUseAccelerateByENV } from '@gp/hooks/useCos/useCOS';
import { fetchDBIGZTencentQCouldMassage } from '@intelligence/services/cos';

export default function MarketTabDetailsDemographics(props: any) {
  const { marketName } = props;
  const [info, setInfo] = useState<any>({});
  const [countrtId, setCountrtId] = useState('');
  const [yearValue, setYearValue] = useState('2022');
  const { formatMessage } = useIntl();

  // 仅预发布、正式 支持COS全球域名加速请求
  const useAccelerate = getUseAccelerateByENV();

  const { getObjectUrl } = useCOS({
    useAccelerate,
    baseCOSConfigFetcher: fetchDBIGZTencentQCouldMassage,
    authorizationFetcher: fetchDBIGZTencentQCouldMassage,
  });

  const options = [
    {
      text: '2021',
      value: '2021',
    },
    {
      text: '2022',
      value: '2022',
    },
  ];

  useEffect(() => {
    const marketNameEn = marketName || history.location.query.marketNameEn;
    setInfo(testBaseInfo[yearValue][marketNameEn] || {});
    setCountrtId(marketNameEn);
  }, []);

  // 根据项目中已有的，上传文件到cos目录和path，点击下载，根据年份和国家ID拼接，例如：/downloadExcel/2022/us.xlsx，文件指向cdn上的目录直接下载
  // 重构download方法，假设cdn上已有cos目录/downloadExcel
  const download = async () => {
    const path = `intelligence_detail/downloadExcel/${yearValue}/${countrtId}.xlsx`;
    if (!path) return;
    const fileKey = `${countrtId}.xlsx`;
    try {
      // console.debug('pathpath', path);
      // console.debug('fileKey', fileKey);
      const { downloadUrl } = await getObjectUrl({ key: path });
      // console.debug('downloadUrldownloadUrl', downloadUrl);
      downloadFileByLinker(`${downloadUrl};filename=${fileKey}`, 'true');
    } catch (exception) {
      console.warn(exception);
    }

    // const downloadElement = document.createElement('a');
    // downloadElement.href = fileUrl;
    // downloadElement.download = `${countrtId}.xlsx`;
    // document.body.appendChild(downloadElement);
    // downloadElement.click();
    // document.body.removeChild(downloadElement);
  };

  // 中英文映射
  const formateTitle = {
    Male: formatMessage({ id: 'dbi_market_male' }),
    Female: formatMessage({ id: 'dbi_market_female' }),
    Other: formatMessage({ id: 'dbi_market_other' }),
    Low: formatMessage({ id: 'dbi_market_low' }),
    Middle: formatMessage({ id: 'dbi_market_middle' }),
    High: formatMessage({ id: 'dbi_market_high' }),
    'Other/Prefer not to answer': formatMessage({ id: 'dbi_market_Other_no_answer' }),
    'Full-time employee': formatMessage({ id: 'dbi_market_full_time_employee' }),
    'Part-time employee': formatMessage({ id: 'dbi_market_part_time_employee' }),
    'Self-employed or independent': formatMessage({ id: 'dbi_market_independent' }),
    'Full-time homemaker': formatMessage({ id: 'dbi_market_homemaker' }),
    Student: formatMessage({ id: 'dbi_market_student' }),
    Unemployed: formatMessage({ id: 'dbi_market_unemployed' }),
    Retired: formatMessage({ id: 'dbi_market_Retired' }),
    'Extended or currently furloughed': formatMessage({ id: 'dbi_market_furloughed' }),
    'Esports Enthusiasts': formatMessage({ id: 'dbi_market_esport_enthusiasts' }),
    'Occasional Viewers': formatMessage({ id: 'dbi_market_occasional_viewers' }),
    'Non-Esports Audience': formatMessage({ id: 'dbi_market_non_esport_audience' }),
    'Total Players': formatMessage({ id: 'dbi_total_player' }),
    'Non Total Players': formatMessage({ id: 'dbi_market_non_total_players' }),
    'Mobile Players': formatMessage({ id: 'dbi_market_mobile_players' }),
    'Non Mobile Players': formatMessage({
      id: 'dbi_market_non_mobile_players',
    }),
    'PC Players': formatMessage({ id: 'dbi_market_pc_players' }),
    'Non PC Players': formatMessage({ id: 'dbi_market_non_pc_players' }),
    'Console Players': formatMessage({ id: 'dbi_market_console_players' }),
    'Non Console Players': formatMessage({
      id: 'dbi_market_non_console_players',
    }),
    'The Ultimate Gamer': formatMessage({ id: 'dbi_market_ultimate_gamer' }),
    'The All-Round Enthusiast': formatMessage({ id: 'dbi_market_all_enthusiast' }),
    'The Bargain Buyer': formatMessage({ id: 'dbi_market_bargain_buyer' }),
    'The Mainstream Gamer': formatMessage({ id: 'dbi_market_mainstream_gamer' }),
    'The Solo Gamer': formatMessage({ id: 'dbi_market_solo_gamer' }),
    'The Community Gamer': formatMessage({ id: 'dbi_market_community_gamer' }),
    'The Hardware Enthusiast': formatMessage({ id: 'dbi_market_hardware_enthusiast' }),
    'The Popcorn Gamer': formatMessage({ id: 'dbi_market_popcorn_gamer' }),
    'The Backseat Viewer': formatMessage({ id: 'dbi_market_backseat_viewer' }),
    'The Time Filler': formatMessage({ id: 'dbi_market_time_filler' }),
    'The Lapsed Gamer': formatMessage({ id: 'dbi_market_lapsed_gamer' }),
    'Not a Persona': formatMessage({ id: 'dbi_market_not_persona' }),
  } as any;

  const data = [
    {
      title: formatMessage({ id: 'dbi_market_total_pop' }),
      num: info.total_population || '-',
      text: 'YoY',
      trend: info.total_population_precent || '-',
      isUp: info.total_population_precent?.indexOf('-') === -1,
    },
    {
      title: formatMessage({ id: 'dbi_market_online_pop' }),
      num: info.online_population || '-',
      text: 'YoY',
      isUp: info.online_population_precent?.indexOf('-') === -1,
      trend: info.online_population_precent || '-',
    },
    {
      title: formatMessage({ id: 'dbi_market_gdp' }),
      num: info.gdp_normal || '-',
      text: 'YoY',
      isUp: info.gdp_normal_precent?.indexOf('-') === -1,
      trend: info.gdp_normal_precent || '-',
    },
    {
      title: formatMessage({ id: 'dbi_market_gdp_per' }),
      num: info.gdp_capita || '-',
      text: 'YoY',
      isUp: info.gdp_capita_precent?.indexOf('-') === -1,
      trend: info.gdp_capita_precent || '-',
      tipText: formatMessage({ id: 'dbi_market_gdp_intro' }),
    },
  ];
  const chartColor = [
    '#5086F3',
    '#5EC8F1',
    '#69D19C',
    '#F5D242',
    '#F19E55',
    '#F17C86',
    '#AD53D4',
    '#7F6FF1',
    '#488E89',
    '#6E7794',
  ];

  const leftList = [
    {
      title: formatMessage({ id: 'dbi_market_gender' }),
      list: info.Gender
        ? Object.keys(info.Gender)?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info.Gender[key],
          color: chartColor[index],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_age_combined' }),
      list: info['Age Combined']
        ? Object.keys(info['Age Combined'])?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info['Age Combined'][key],
          color: chartColor[index],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_education' }),
      list: info.Education
        ? Object.keys(info.Education)?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info.Education[key],
          color: chartColor[index],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_income' }),
      list: info.Income
        ? Object.keys(info.Income)?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info.Income[key],
          color: chartColor[index],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_work_situation' }),
      list: info['Work situation']
        ? Object.keys(info['Work situation'])?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info['Work situation'][key],
          color: chartColor[index],
        }))
        : [],
    },
  ];

  const rightList = [
    {
      title: formatMessage({ id: 'dbi_market_esport_audience' }),
      list: info['Esports Audience']
        ? Object.keys(info['Esports Audience'])?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info['Esports Audience'][key],
          color: chartColor[index],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_players' }),
      list: info.Players
        ? Object.keys(info.Players)?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info.Players[key],
          color: chartColor[index % 2],
        }))
        : [],
    },
    {
      title: formatMessage({ id: 'dbi_market_persona' }),
      list: info.Persona
        ? Object.keys(info.Persona)?.map((key, index) => ({
          title: formateTitle[key] || key,
          num: info.Persona[key],
          color: chartColor[index],
        }))
        : [],
    },
  ];

  return (
    <div className="dbi-market-tabdetails--demographics">
      <Justify
        className="demographics-margin"
        left={
          <Select
            className="dbi-marketprofile-select"
            appearance="button"
            matchButtonWidth
            options={options}
            value={yearValue}
            onChange={(value: any) => {
              if (value != yearValue) {
                setYearValue(value);
                setInfo(testBaseInfo[value][countrtId] || {});
              }
            }}
            placeholder="请选择年份"
            button={(option: any) => (
              <div className="select-button">
                <div className="select-button-text">{formatMessage({ id: 'dbi_date' })}</div>
                {
                  options.filter((e) => {
                    return e.value == yearValue;
                  })[0]?.text
                }
              </div>
            )}
          />
        }
        right={
          <Bubble placement="top-end" dark content={formatMessage({ id: 'dbi_info_download_tip' })}>
            <Button icon="download" className="ns-btn--icon" title="下载" onClick={download} />
          </Bubble>
        }
      />
      <Row className="demographics-buttom">
        {data.map((item: any, index: any) => {
          return (
            <Col span={6} key={index}>
              <CardSlot>
                <MarketCardContext data={item} tipText={item.tipText} />
              </CardSlot>
            </Col>
          );
        })}
      </Row>
      <Row className="demographics-context">
        <Col span={12} className="demographics-context-left">
          <CardSlot>
            {leftList.map((item: any, index: any) => {
              return (
                <div className="demographics-card">
                  <ProgressCard key={index} data={item} />
                </div>
              );
            })}
          </CardSlot>
        </Col>
        <Col span={12} className="demographics-context-right">
          {rightList.map((item: any, index: any) => {
            return (
              <CardSlot key={index} className={index == 1 ? 'demographics-card' : ''}>
                <ProgressCard data={item} />
              </CardSlot>
            );
          })}
        </Col>
      </Row>
    </div>
  );
}
